import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingFutureEvents } from "./RacingFutureEvents";
import { RacingFutureEventsData } from "./data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as LOCALMOCKS from "../../mocks";
let _: typeof MOCKSTYPE;
let _localMocks: typeof LOCALMOCKS;
let PageMethodsMock;
let RacingPageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
}

export class RacingFutureEventsRoot extends BaseBlock {
    dataProvider!: RacingFutureEventsData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {}
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {

            // setup data mocks for debug build
            this.dataProvider = new RacingFutureEventsData({
                pageMethods: new PageMethodsMock(),
                racingPageMethods: new RacingPageMethodsMock()
            }, () => { });

            // setup dictionary for debug build
            this.options.dict = BaseDict;

            //export data store to window for debug purposes
            window["RacingFutureEventsDATA"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingFutureEventsData(options.dataProvider, OpenRacingGame);
        }

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = {...BaseDict, ...(options.dict || {})};

        // merge default and CMS options
        this.options.cms = {...config, ...(options.cms || {})};
    }

    activate() {
        return super.activate(
            <RacingFutureEvents dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["RacingFutureEvents"] = RacingFutureEventsRoot;
broadcastBlockLoad("RacingFutureEvents");